import { PropsWithChildren } from 'react';
import { SuperTokensWrapper } from 'supertokens-auth-react';
import * as Sentry from '@sentry/react';
import { MantineProvider } from '@mantine/core';
import { theme } from './Styles/Theme.ts';
import {
    ConfigCatProvider,
    createConsoleLogger,
    LogLevel,
} from 'configcat-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { OwnApolloProvider } from './OwnApolloProvider.tsx';
import { Env } from './Env.ts';

const queryClient = new QueryClient();

export function Wrappers(props: PropsWithChildren) {
    return (
        <Sentry.ErrorBoundary showDialog>
            <QueryClientProvider client={queryClient}>
                <ConfigCatProvider
                    sdkKey={Env.VITE_CONFIG_CAT}
                    options={{ logger: createConsoleLogger(LogLevel.Info) }}
                >
                    <MantineProvider
                        withGlobalStyles
                        withNormalizeCSS
                        theme={theme}
                    >
                        <SuperTokensWrapper>
                            <OwnApolloProvider>
                                {props.children}
                            </OwnApolloProvider>
                        </SuperTokensWrapper>
                    </MantineProvider>
                </ConfigCatProvider>
            </QueryClientProvider>
        </Sentry.ErrorBoundary>
    );
}
